import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../core/actions/actions';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../translations/connectedIntlProvider';
import IState from '../../core/models/IState';
import { toast } from 'react-toastify';
import noData from '../../assets/Images/no_data.svg';
import dashboardIcon from '../../assets/Images/dashboard.svg';
import { injectIntl } from 'react-intl';
import modelEnum from '../../constants/model.enum';
import RoutesConstants from '../../shared/components/Routes/routes.constants';
import { IAQDeviceData } from '../../core/models/IIAQDevicesState';
import './iaq-sensor.css';
import { convertLocalToUTC, emptyValueHyphen } from '../../constants/common.constant';
import { getUserTypeFromLocalStorage } from '../../helpers/local.storage.helpers';
import NoDataComponent from '../../shared/components/NoData/NoDataComponent';
import Loader from '../../shared/components/Loader/Loader';
import Pagination from '../../shared/components/Grid/Pagination'
import IPageInfo from '../../models/IPageInfo';
import IPageLimit from '../../models/IPageLimit';
import AddSensorFilterPopupHOC from '../Sensor/hoc/AddSensorFilterPopupHOC';
import IAQSensorFilter from './IAQSensorFilter'
import { reset } from 'redux-form';

const IAQSensors = (props: any) => {
    const language = useSelector((state: IState) => state.preferences.language);
    const dispatch = useDispatch();
    const [selectedSensor, setSelectedSensor] = useState<boolean>(false);
    const [selectedData, setSelectedData] = useState<IAQDeviceData | null>(null);
    const { sensor }: any = useSelector((state: IState) => state.sensor);
    const { iaqDevicesList, iaqLegendDetailsVM }: any = useSelector((state: IState) => state.iaqDevices);
    const [pageInfo, setPageInfo] = useState<IPageInfo>({
        currentPage: 1,
        totalPages: 1,
        isPagerChange: false,
        isRefreshPage: false
    });
    let paginationData: any = {
        CurrentPage: 1,
        PageSize: 10,
        OrderBy: 'desc',
        SensorLocationParam: null
    }
    const pager: IPageLimit = useSelector((state: IState) => { return state.pager });
    const [disablePagination, setDisablePagination] = useState<boolean>(false);
    const [hasFilter, setHasFilter] = useState<boolean>(false);

    useEffect(() => {
        if (selectedSensor && !sensor.loading) {
            setSelectedSensor(false);
            if (sensor.sensor) {
                const device = { ...sensor.sensor, CustomerId: sensor.sensor.CustomerID };
                props.history.push({
                    pathname: RoutesConstants.IAQRealTimeView,
                    state: {
                        iccid: device.ICCID,
                        model: device.Model,
                        building: device.Building,
                        location: device.Location,
                        floor: device.Floor,
                        customerId: device.CustomerId,
                        room: device.Room,
                        latestPayloadTime: selectedData?.CreatedAt,
                        fromParentPath: RoutesConstants.IAQSensor,
                    },
                });
                setSelectedData(null);
            } else {
                toast.error(formatMessage('Invalid_ICCID'));
                setSelectedData(null);
            }
        }
    }, [sensor.loading]);

    const redirectClickHandler = (row: any) => {
        setSelectedSensor(true);
        setSelectedData(row);
        dispatch(actions.getSensorById(row.ICCID));
    };

    const refreshClickHandler = () => {
        if (pager.isPageLimitLoaded)
            GetAllIAQDevices();
        // dispatch(actions.getIAQLegendDetails());
    };

    /**
     * Returns "good" | "moderate" | "unhealthy" based on AQI value.
     * Adjust thresholds to match your business rules.
     */
    const getAQIStatus = (airIndex: number): 'good' | 'moderate' | 'unhealthy' | 'neutral' => {
        let aqiStatus: 'good' | 'moderate' | 'unhealthy' | 'neutral' = 'neutral';
        if (airIndex === null) return "neutral"
        if (airIndex <= 50) aqiStatus = 'good';
        else if (airIndex <= 100) aqiStatus = 'moderate';
        else aqiStatus = 'unhealthy';
        return aqiStatus;
    };

    // const getMetricStatus = (name: string, value: number): string => {
    //     const color = getKPIThresholdRange(name, value);
    //     if (!color) return '';

    //     const colorMap: Record<string, string> = {
    //         Green:  'good',
    //         Yellow: 'moderate',
    //         Red: 'unhealthy',
    //     };

    //     return colorMap[color] ?? '';
    // };

    const openSensorFilterHandler = (ob: any, bool: boolean) => {
        props.addSensorFilterToggleHandler();
    }

    const onClearFilter = () => {
        setHasFilter(false)
        localStorage.removeItem('IAQSensor.Filter');
        dispatch(actions.resetIAQSensorFilterState())
        dispatch(reset('IAQSensorFilterForm'));
        GetAllIAQDevices();
    }

    const onPageChanged = (pageNumber: number) => {
        if (pageInfo.totalPages) {
            setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
        } else {
            setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true, totalPages: 1 });
        }
    }

    const setIsRefreshPage = () => {
        setPageInfo({ ...pageInfo, isRefreshPage: false });
    }

    const onPageLimitChanged = (evt: any) => {
        let pages: number;
        let pageSize = +evt.target.value;
        pages = props.data && Math.ceil(props.data.length / pageSize)
        setPageInfo({ ...pageInfo, currentPage: 1, totalPages: pages, isPagerChange: false });
        dispatch(actions.updatePagerPageLimit(pageSize));
    }

    const GetAllIAQDevices = () => {
        paginationData.CurrentPage = pageInfo.currentPage;
        paginationData.PageSize = pager.pageLimit;
        let localStorageValue = localStorage.getItem('IAQSensor.Filter');
        let value = localStorageValue ? JSON.parse(localStorageValue) : {};
        setDisablePagination(true);
        value.SensorType = modelEnum.IAQ.toLowerCase();
        paginationData.SensorLocationParam = {
            ...value,
            LatestPayloadStartDateTime: value.LatestPayloadStartDateTime || null,
            LatestPayloadEndDateTime: value.LatestPayloadEndDateTime || null
        };
        if (localStorageValue !== null) {
            let tempSensorLocationParams = { ...paginationData.SensorLocationParam };
            dispatch(actions.getFilterIAQSensorsService({
                ...paginationData,
                SensorLocationParam: {
                    ...tempSensorLocationParams,
                    LatestPayloadStartDateTime: convertLocalToUTC(tempSensorLocationParams.LatestPayloadStartDateTime),
                    LatestPayloadEndDateTime: convertLocalToUTC(tempSensorLocationParams.LatestPayloadEndDateTime)
                }
            }));
        } else {
            dispatch(actions.getIAQDevices(pageInfo.currentPage, pager.pageLimit, getUserTypeFromLocalStorage() === 'Administrator'));
        }
    };

    const setHasFilterFun = (values: any) => {
        if (values === "")
            setHasFilter(false);
        else
            setHasFilter(true);
    }
    
    useEffect(() => {
        dispatch(actions.getPageLimit());
         let localStorageValue = localStorage.getItem('IAQSensor.Filter')!;
        dispatch(actions.resetUserSettingState());
        var value = JSON.parse(localStorageValue);
        if (value) {
          setHasFilter(true);
        }
        return (() => {
            dispatch(actions.resetIAQDevicesState());
            // dispatch(actions.resetIAQLegendDetailsState());
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    

    useEffect(() => {
        refreshClickHandler();
    }, [language]);


    useEffect(() => {
        if (iaqLegendDetailsVM.error) {
            toast.error(formatMessage(iaqLegendDetailsVM.error))
            // dispatch(actions.resetIAQLegendDetailsState());
        }
    }, [iaqLegendDetailsVM.error]);

    useEffect(() => {
        if (pager.isPageLimitLoaded) {
            GetAllIAQDevices();
        }
    }, [pager.isPageLimitLoaded, pager.pageLimit]);

    useEffect(() => {
        if (pageInfo.isPagerChange) {
            GetAllIAQDevices();
        }
    }, [pageInfo.currentPage]);

    useEffect(() => {
        if (!iaqDevicesList.loading && iaqDevicesList.data !== undefined) {
            setPageInfo({
                ...pageInfo,
                totalPages: iaqDevicesList.data.TotalPages,
                isRefreshPage: iaqDevicesList.data.CurrentPage === 1
            });
            setDisablePagination(false);
        }
    }, [iaqDevicesList.loading]);

    return (
        <React.Fragment>
            {
                props.showAddSensorFilterPopup && (
                    <IAQSensorFilter
                        pageInfo={pageInfo}
                        pager={pager}
                        setHasFilterFun={setHasFilterFun}
                        clearfilter={onClearFilter}
                        modalClosed={props.addSensorFilterToggleHandler} />
                )
            }
            <div className="icon-nav navbar-fixed-top device-nav-bar">
                <div className="container-fluid">
                    <div className="filter-left-area">
                        <ul>
                            <li>
                                <h1>
                                    <img src={dashboardIcon} alt="" />
                                    <FormattedMessage id="iaq_sensors" />
                                </h1>
                            </li>
                        </ul>
                    </div>
                    <div className="add-list float-right">
                        <ul>
                            <li title={formatMessage('Filter')}>
                                <a data-toggle="modal" onClick={() => openSensorFilterHandler({ id: -1, iccid: '' }, false)} data-target="#addSensorFilter">
                                    <svg width="15" height="15" fill="#747474" className="bi bi-funnel" viewBox="0 0 16 16">
                                        <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
                                    </svg>
                                </a>
                            </li>
                            {
                                hasFilter &&  //TODO: Change Icon and call Clear Filter Functionality
                                <li title={formatMessage('Button_Clear_Filter')}>
                                    <a data-toggle="modal" onClick={onClearFilter} data-target="#addSensor">
                                        <svg width="15" height="15" fill="#747474" className="clearfilter" viewBox="0 0 100.000000 100.000000"
                                            preserveAspectRatio="xMidYMid meet">
                                            <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" stroke="none">
                                                <path d="M7 993 c-4 -3 -7 -23 -7 -43 0 -34 13 -51 158 -205 l157 -168 5 -185 5 -186 107 -64 c59 -35 112 -61 117 -57 7 4 11 89 11 248 l1 242 160 169 c157 167 160 170 157 210 l-3 41 -431 3 c-237 1 -434 -1 -437 -5z m831 -52 c-2 -11 -70 -91 -153 -179 l-150 -161 -95 0 -95 0 -150 161 c-82 88 -151 168 -153 179 -3 18 9 19 398 19 389 0 401 -1 398 -19z m-318 -591 c0 -116 -2 -210 -5 -210 -2 0 -38 21 -80 46 l-75 45 0 165 0 164 80 0 80 0 0 -210z" />
                                                <path d="M644 349 c-4 -6 28 -45 72 -90 l79 -79 -80 -80 c-63 -63 -77 -82 -67 -92 10 -10 29 4 92 67 l80 80 80 -80 c63 -63 82 -77 92 -67 10 10 -4 29 -67 92 l-80 80 80 80 c63 63 77 82 67 92 -10 10 -29 -4 -92 -67 l-80 -80 -78 78 c-42 42 -80 77 -84 77 -4 0 -10 -5 -14 -11z" />
                                            </g>
                                        </svg>
                                    </a>
                                </li>
                            }
                            <li title={formatMessage('Refresh')}>
                                <a data-toggle="modal" onClick={refreshClickHandler}>
                                    <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                                        <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                                    </svg>
                                </a>
                            </li>
                            <li className="page-number">
                                <Pagination isRefreshPage={pageInfo.isRefreshPage} totalPages={pageInfo.totalPages} pageLimit={pager.pageLimit} onPageChanged={onPageChanged} disablePagination={disablePagination} setIsRefreshPage={setIsRefreshPage} />
                            </li>
                            <li className="page-count-no">
                                <select className='pageLimit' onChange={onPageLimitChanged} value={pager.pageLimit}>
                                    {pager.pageLimitOptions.map((op: any) => <option key={op} value={op}>{op}</option>)}
                                </select>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="p-2">
                {iaqDevicesList.loading ? (<Loader />) :
                    <div className="row g-0 justify-content-center" style={{ height: 'calc(100vh - 110px)' }}>
                        <div className="card card-body px-5">
                            <div className="container-fluid p-0">
                                <div className="iaq-grid">
                                    {iaqDevicesList?.data && iaqDevicesList.data?.IAQDevices && iaqDevicesList.data.IAQDevices?.length > 0 && iaqDevicesList.data.IAQDevices.map((item: IAQDeviceData) => {
                                        const aqiStatus = getAQIStatus(item.AirIndex);

                                        return (
                                            <div className="iaq-grid-item" key={item.ICCID}>
                                                <div
                                                    className={`iaq-card iaq-card--${aqiStatus}`}
                                                    onClick={() => redirectClickHandler(item)}
                                                >
                                                    {/* Left color strip */}
                                                    <div className={`iaq-card__strip iaq-card__strip--${aqiStatus}`} />

                                                    {/* AQI circle */}
                                                    <div className="iaq-card__aqi-col">
                                                        <div className={`iaq-aqi-circle iaq-aqi-circle--${aqiStatus}`}>
                                                            <span className="iaq-aqi-circle__num">{item.AirIndex && Math.round(item.AirIndex)}</span>
                                                            <span className="iaq-aqi-circle__lbl">
                                                                <FormattedMessage id="aqi" />
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Right: Sensor ID + metrics */}
                                                    <div className="iaq-card__info">
                                                        <div className="iaq-card__sensor">
                                                            <span className="iaq-card__sensor-lbl">
                                                                <FormattedMessage id="Sensor_Label_CustomerId" />
                                                            </span>
                                                            <span
                                                                className={`iaq-card__sensor-id ${(item?.CustomerId && item?.CustomerId.length > 20) ? 'iaq-card__sensor-id--long' : ''}`}
                                                                title={item.CustomerId}
                                                            >
                                                                {item?.CustomerId || emptyValueHyphen}
                                                            </span>
                                                        </div>

                                                        <div className="iaq-card__metrics">
                                                            <div className="iaq-metric">
                                                                <span className="iaq-metric__lbl">
                                                                    <FormattedMessage id="temperature" />
                                                                </span>
                                                                {/* <span className={`iaq-metric__val iaq-metric__val--${getMetricStatus('temperature', item.Temprature)}`}> */}
                                                                <span className="iaq-metric__val">
                                                                    {item.Temprature}°C
                                                                </span>
                                                            </div>
                                                            <div className="iaq-metric">
                                                                <span className="iaq-metric__lbl">
                                                                    <FormattedMessage id="humidity" />
                                                                </span>
                                                                <span className="iaq-metric__val">
                                                                    {item.Humidity}%
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                    }
                                </div>
                            </div>
                        {
                            !(iaqDevicesList?.data && iaqDevicesList.data?.IAQDevices && iaqDevicesList.data.IAQDevices?.length > 0) &&
                                <NoDataComponent image={noData} imageAlt={'No Device'} message={'no_iaq_sensors_available'} />
                        }
                        </div>
                    </div>
                }
            </div>
        </React.Fragment>
    );
};

export default injectIntl(AddSensorFilterPopupHOC(IAQSensors));
